"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.form.title.label': 'Título de la Pregunta <span class="text-danger">*</span>',
    'question.form.title.placeholder': 'Ingrese el título de la pregunta',
    'question.form.type.label': 'Tipo de Pregunta',
    'question.form.type.placeholder': 'Seleccione el tipo de pregunta',
    'question.form.required.label': 'Requerido',
    'question.form.description.label': 'Descripción (Opcional)',
    'question.form.description.placeholder': 'Ingrese la descripción de la pregunta',
    'question.form.options.label': 'Opciones',
    'question.form.options.add': 'Agregar Opción',
    'question.form.option.value.placeholder': 'Valor de la opción',
    'question.form.option.label.placeholder': 'Etiqueta de la opción',
    'question.form.option.remove': 'Eliminar opción',
    'question.form.options.empty': 'Aún no se han agregado opciones. Haga clic en "Agregar Opción" para empezar.',
};
